<template>
  <v-dialog v-model="decomDialog" persistent width="600">
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip
        top
        color="primary"
      >
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            color="red"
            icon
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
          >
            <v-icon>mdi-delete-forever-outline</v-icon>
          </v-btn>
        </template>
        <span>Decommission Contract</span>
      </v-tooltip>
    </template>
    <v-card>
      <v-card-title class="text-h5 accent lighten-2">
        Decommission Contract
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-alert
                type="warning"
                outlined
                prominent
                text
              >
                This will mark the contract and all associated items as deleted. Are you sure you want to continue?
              </v-alert>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" class="text-center">
              <v-form
                ref="decomContractForm"
              >
                <v-text-field
                  v-model="reference"
                  label="Reference"
                  :rules="[rules.required, rules.reference]"
                />
                <v-text-field
                  v-model="contract"
                  label="Confirm Contract"
                  :rules="[rules.required, rules.contract]"
                />
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close"> CANCEL </v-btn>
        <v-btn color="accent" @click="save"> CONFIRM </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'DecomDialog',
    props: {
      contractNumber: String
    },
    data () {
      return {
        decomDialog: false,
        contract: '',
        reference: '',
        rules: {
          required: value => !!value || 'Required.',
          reference: value => {
            const pattern = /^[rstRST]?[0-9]{6,}$/
            if (value) {
              return pattern.test(value) || 'Invalid Reference.'
            } else {
              return true
            }
          },
          contract: value => {
            if (value !== this.contractNumber) {
              return 'Contract number is not correct.'
            } else {
              return true
            }
          }
        },
      }
    },
    methods: {
      close () {
        this.decomDialog = false
        this.contract = ''
        this.reference = ''
      },
      save () {
        if (this.$refs.decomContractForm.validate()) {
          this.$emit('decomContract', { contract: this.contract, reference: this.reference })
          this.decomDialog = false
        } else {
          // Do nothing
        }
      }
    }
  }
</script>